import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

export type Workstream = {
  workstreamId: string;
  organisationId: string;
  workstreamName: string;
};

export type WorkstreamsResponse = ResponseType<Workstream[]>;

function useAllWorkstreamsQuery(enabled = true) {
  return useQuery<
    AxiosResponseAndError<WorkstreamsResponse>["response"],
    AxiosResponseAndError<WorkstreamsResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.workstreams],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.project + "/workstreams"),
    enabled: enabled,
    staleTime: 60000,
  });
}

export default useAllWorkstreamsQuery;
